/**
 * @module
 * @format
 */

import {MailFormController} from 'nova';
import {popup} from '@acng/frontend-discovery';

import {post} from '../../core/service/backend.js';
import {t} from '../../locale/config/translate.js';
import {getLocalOverlay} from '../../core/service/overlay.js';

class MailAddressChange extends MailFormController {
  /**
   * @param {HTMLFormElement} form
   * @param {FormData} data
   */
  async submit(form, data) {
    const url = 'user/change-mail';

    await post(url, data, form, async (error) => {
      if (error.httpStatus == 409) {
        await popup(form).warn(await t('userPool.changeEmailEntryAlreadyExists'));

        throw null;
      }

      throw error;
    });

    await popup(form).info(await t('userPool.changeEmailCheckMail'));
    getLocalOverlay(form)?.close();
  }
}

export {MailAddressChange};
